export function platformIconData(platform) {
  const assetIcons = {
    Instagram: '/Instagram_logo.svg',
    TikTok: '/tik-tok-logo.avif',
    Douyin: '/tik-tok-logo.avif',
    Xiaohongshu: '/xhslogo.png',
  };
  if (assetIcons[platform]) return assetIcons[platform];
  const icons = {
    Instagram: { bg: '#E4405F', fg: '#ffffff', text: '◎' },
    TikTok: { bg: '#111111', fg: '#ffffff', text: '♪' },
    Douyin: { bg: '#111111', fg: '#ffffff', text: '♪' },
    Xiaohongshu: { bg: '#ff2442', fg: '#ffffff', text: '小' },
    X: { bg: '#111111', fg: '#ffffff', text: 'X' },
  };
  const icon = icons[platform] || { bg: '#174f49', fg: '#ffffff', text: platform.slice(0, 1) };
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56"><rect width="56" height="56" rx="14" fill="${icon.bg}"/><text x="28" y="36" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="26" font-weight="800" fill="${icon.fg}">${icon.text}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

export function platformColor(platform) {
  return (
    {
      Instagram: '#E4405F',
      TikTok: '#111111',
      Douyin: '#111111',
      Xiaohongshu: '#ff2442',
      X: '#111111',
    }[platform] || '#174f49'
  );
}

export function followerCountLabel() {
  return 'followers';
}

const PLATFORM_HOME_URLS = {
  Instagram: 'https://instagram.com',
  TikTok: 'https://tiktok.com',
  Douyin: 'https://www.douyin.com',
  Xiaohongshu: 'https://www.xiaohongshu.com',
  X: 'https://x.com',
};

export function platformHomeUrl(platform) {
  return PLATFORM_HOME_URLS[platform] || null;
}

export function socialProfileUrl(social) {
  const cleanHandle = (social.handle || '').replace(/^@/, '').trim();
  if (!cleanHandle) return platformHomeUrl(social.platform);
  if (social.platform === 'Instagram') return `https://instagram.com/${cleanHandle}`;
  if (social.platform === 'TikTok') return `https://tiktok.com/@${cleanHandle}`;
  if (social.platform === 'X') return `https://x.com/${cleanHandle}`;
  return platformHomeUrl(social.platform);
}

export function hasBreakdown(items = []) {
  return items.some((item) => item.category && item.value !== '' && item.value !== undefined);
}

const COUNTRY_CODES = {
  Singapore: 'SG',
  Malaysia: 'MY',
  Indonesia: 'ID',
  Thailand: 'TH',
  Vietnam: 'VN',
  Philippines: 'PH',
  Myanmar: 'MM',
  Cambodia: 'KH',
  Laos: 'LA',
  Brunei: 'BN',
  'Timor-Leste': 'TL',
  Afghanistan: 'AF',
  Albania: 'AL',
  Algeria: 'DZ',
  Andorra: 'AD',
  Angola: 'AO',
  Argentina: 'AR',
  Armenia: 'AM',
  Australia: 'AU',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  Bahamas: 'BS',
  Bahrain: 'BH',
  Bangladesh: 'BD',
  Barbados: 'BB',
  Belarus: 'BY',
  Belgium: 'BE',
  Belize: 'BZ',
  Benin: 'BJ',
  Bhutan: 'BT',
  Bolivia: 'BO',
  'Bosnia and Herzegovina': 'BA',
  Botswana: 'BW',
  Brazil: 'BR',
  Bulgaria: 'BG',
  'Burkina Faso': 'BF',
  Burundi: 'BI',
  'Cabo Verde': 'CV',
  Cameroon: 'CM',
  Canada: 'CA',
  Chad: 'TD',
  Chile: 'CL',
  China: 'CN',
  Colombia: 'CO',
  'Costa Rica': 'CR',
  Croatia: 'HR',
  Cuba: 'CU',
  Cyprus: 'CY',
  Czechia: 'CZ',
  Denmark: 'DK',
  Djibouti: 'DJ',
  'Dominican Republic': 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  'El Salvador': 'SV',
  Estonia: 'EE',
  Eswatini: 'SZ',
  Ethiopia: 'ET',
  Fiji: 'FJ',
  Finland: 'FI',
  France: 'FR',
  Gabon: 'GA',
  Gambia: 'GM',
  Georgia: 'GE',
  Germany: 'DE',
  Ghana: 'GH',
  Greece: 'GR',
  Guatemala: 'GT',
  Guinea: 'GN',
  Guyana: 'GY',
  Haiti: 'HT',
  Honduras: 'HN',
  'Hong Kong': 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Iran: 'IR',
  Iraq: 'IQ',
  Ireland: 'IE',
  Israel: 'IL',
  Italy: 'IT',
  Jamaica: 'JM',
  Japan: 'JP',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  Kuwait: 'KW',
  Kyrgyzstan: 'KG',
  Latvia: 'LV',
  Lebanon: 'LB',
  Lesotho: 'LS',
  Liberia: 'LR',
  Libya: 'LY',
  Liechtenstein: 'LI',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Macao: 'MO',
  Madagascar: 'MG',
  Malawi: 'MW',
  Maldives: 'MV',
  Mali: 'ML',
  Malta: 'MT',
  Mauritania: 'MR',
  Mauritius: 'MU',
  Mexico: 'MX',
  Moldova: 'MD',
  Monaco: 'MC',
  Mongolia: 'MN',
  Montenegro: 'ME',
  Morocco: 'MA',
  Mozambique: 'MZ',
  Namibia: 'NA',
  Nepal: 'NP',
  Netherlands: 'NL',
  'New Zealand': 'NZ',
  Nicaragua: 'NI',
  Niger: 'NE',
  Nigeria: 'NG',
  'North Korea': 'KP',
  'North Macedonia': 'MK',
  Norway: 'NO',
  Oman: 'OM',
  Pakistan: 'PK',
  Panama: 'PA',
  'Papua New Guinea': 'PG',
  Paraguay: 'PY',
  Peru: 'PE',
  Poland: 'PL',
  Portugal: 'PT',
  Qatar: 'QA',
  Romania: 'RO',
  Russia: 'RU',
  Rwanda: 'RW',
  'Saudi Arabia': 'SA',
  Senegal: 'SN',
  Serbia: 'RS',
  Seychelles: 'SC',
  'Sierra Leone': 'SL',
  Slovakia: 'SK',
  Slovenia: 'SI',
  Somalia: 'SO',
  'South Africa': 'ZA',
  'South Korea': 'KR',
  'South Sudan': 'SS',
  Spain: 'ES',
  'Sri Lanka': 'LK',
  Sudan: 'SD',
  Suriname: 'SR',
  Sweden: 'SE',
  Switzerland: 'CH',
  Syria: 'SY',
  Taiwan: 'TW',
  Tajikistan: 'TJ',
  Tanzania: 'TZ',
  Togo: 'TG',
  'Trinidad and Tobago': 'TT',
  Tunisia: 'TN',
  Turkey: 'TR',
  Turkmenistan: 'TM',
  Uganda: 'UG',
  Ukraine: 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'GB',
  'United States': 'US',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  Venezuela: 'VE',
  Yemen: 'YE',
  Zambia: 'ZM',
  Zimbabwe: 'ZW',
};

export function countryFlag(location) {
  const code = COUNTRY_CODES[location];
  if (!code) return '';
  return code.replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
}
